module.exports = __webpack_public_path__ + "img/mazda.10d73e0f.jpeg";